import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Heading } from './Heading'
import { LayoutContentWrapper } from 'components/LayoutContentWrapper/LayoutContentWrapper'
import { breakpointFrom } from 'utils/breakpoints'

type WrapperProps = { backgroundColor: string; isSingleImageHero?: boolean }

const StyledWrapper = styled.section<WrapperProps>`
  margin-top: ${({ theme }) => theme.space[7]};
  background: ${({ backgroundColor }) => backgroundColor};

  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    position: relative;
    :after {
      content: '';
      padding-bottom: ${({ isSingleImageHero }) =>
        isSingleImageHero ? '40%' : '50%'};
      display: block;
      position: relative;
    }
  }
`

const StyledLayoutContentWrapper = styled(LayoutContentWrapper)`
  height: 100%;

  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    position: absolute;
    left: 0;
    right: 0;
  }
`

const StyledHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 364px;

  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    width: 50%;
    max-width: max-content;
    padding-right: 72px;
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    padding-right: 110px;
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    padding-right: 148px;
  }
`

const StyledChildrenWrapper = styled.div`
  height: 50vw;

  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
  }
`

type HeroProps = {
  children: ReactNode
  backgroundColor: string
  title: string
  isSingleImageHero?: boolean
}

export const Hero = ({
  children,
  backgroundColor,
  title,
  isSingleImageHero,
}: HeroProps) => {
  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
      isSingleImageHero={isSingleImageHero}
    >
      <StyledLayoutContentWrapper>
        <StyledHeadingContainer>
          <Heading title={title} />
        </StyledHeadingContainer>
      </StyledLayoutContentWrapper>
      <StyledChildrenWrapper>{children}</StyledChildrenWrapper>
    </StyledWrapper>
  )
}
